import React, { useEffect } from 'react';
import { Form, FormikProvider, useFormik } from 'formik';
import { createDocument, updateDocumentByID } from 'apis/customApiHandler';
import { useQuery, useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import { getAllData } from 'apis/customApiHandler';
import InputField from 'components/formik/InputField';
import Model from 'components/Modal';
import ReactSelect from 'react-select';
import { Button } from 'styled';

const Add = ({ data, handleClick }) => {
  const queryClient = useQueryClient();
  const { data: allMakes } = useQuery(['vehicle-make-master'], () =>
    getAllData('/vehicle-make-master', {
      limit: 250,
      page: 1,
    })
  );
  const { data: allModels } = useQuery(['vehicle-model-master'], () =>
    getAllData('/vehicle-model-master', {
      limit: 250,
      page: 1,
    })
  );

  const getFormValues = (data)=>{
    return {
      make: data?.make?._id || "",
      model: data?.model?._id || "",
      name: data?.name || "",
      axleConfiguration: data?.axleConfiguration || "",
      wheelCount: data?.wheelCount || "",
      // agreement: data?.agreement || "",
      tyrePositions:
        (data?.tyrePositions &&
          data?.tyrePositions.map((tp) => {
            return {
              value: tp,
              label: tp,
            };
          })) ||
        "",
        automaticPositions: data?.automaticPositions || Array.from({ length: data?.wheelCount || 0 }, () => ({ position: '', rotateWith: '' }))

    }
  }

  useEffect(()=>{
    formik.setValues({
      ...getFormValues(data)
    })
  }, [data])

  const tyrePositionsOptions = [
    'FL',
    'FR',
    'DLO',
    'DLI',
    'DRO',
    'DRI',
    'DLO1',
    'DLI1',
    'DRO1',
    'DRI1',
    'DLO2',
    'DLI2',
    'DRO2',
    'DRI2',
    'TLO1',
    'TLI1',
    'TRO1',
    'TRI1',
    'TLO2',
    'TLI2',
    'TRO2',
    'TRI2',
    'TLO3',
    'TLI3',
    'TRO3',
    'TRI3',
    'STP',
    'STP1',
    'STP2',
    'FL1',
    'FR1',
    'FL2',
    'FR2',
    'LLO',
    'LLI',
    'LRO',
    'LRI',
    'LL1',
    'LR1',
    'RLO',
    'RLI',
    'RRO',
    'RRI',
    'RL1',
    'RL2',
    'RR1',
    'RR2',
    'TL1',
    'TL2',
    'TR1',
    'TR2',
    'LL2',
    'LR2',
    'RL',
    'RR',
  ].map((item) => ({
    label: item,
    value: item,
  }));
  const formik = useFormik({
    initialValues: {
      ...getFormValues(data)
    },
    onSubmit: async (values) => {
      // Object.keys(values).forEach((key) => {
      //   if (values[key] === "") {
      //     delete values[key];
      //   }
      // });

      values.tyrePositions = values.tyrePositions.map(
        (position) => position.value
      );
      let configurationData;
      if (data && data._id) {
        configurationData = await updateDocumentByID(
          'vehicle-configuration-master',
          data._id,
          values
        );
      } else {
        configurationData = await createDocument(
          'vehicle-configuration-master',
          values
        );
      }
      if (configurationData && configurationData.data) {
        toast.success('created successfully');
        await queryClient.fetchQuery('vehicle-configuration-master', () =>
          getAllData('/vehicle-configuration-master', {
            limit: 2000,
            page: 1,
          })
        );

        queryClient.invalidateQueries('vehicle-configuration-master');
      }

      handleClick();
    },

    validate: (values) => {
      const errors = {};
      // console.log(values.tyrePositions);
      if (!values.name) errors.name = 'Required';
      if (!values.wheelCount) errors.wheelCount = 'Required';
      if (!values.make) errors.make = 'Required';
      if (!values.model) errors.model = 'Required';
      if (!values.tyrePositions) errors.tyrePositions = 'Required';
      else if (values.tyrePositions.length !== parseInt(values.wheelCount))
        errors.tyrePositions =
          'Selected tyre postions should be equal to wheel count';

      if (values.tyrePositions.length) {
        let allPositionsSame = true;

        // Check if all rotateWith fields are the same as their positions
        values.automaticPositions.forEach((pos, index) => {
          if (pos.position !== pos.rotateWith) {
            allPositionsSame = false;
          }
        });

        if (allPositionsSame) {
          if (!errors.automaticPositions) errors.automaticPositions = [];
          values.automaticPositions.forEach((pos, index) => {
            errors.automaticPositions[index] =
              'Position and Rotate With cannot be the same';
          });
        } else {
          // Validate individual rotateWith values
          values.automaticPositions.forEach((pos, index) => {
            if (
              pos.rotateWith &&
              !values.tyrePositions.some((tp) => tp.value === pos.rotateWith)
            ) {
              if (!errors.automaticPositions) errors.automaticPositions = [];
              errors.automaticPositions[index] =
                'Rotation With must be one of the selected tyre positions';
            }
          });
        }
      }
      return errors;
    },
  });
  // console.log(formik.values)vbnm,.'
  const getAllModels = () => {
    const options = [];
    if (formik.values.make && allModels?.data?.length > 0) {
      allModels.data.map((model) => {
        //console.log(formik.values.make, model.make._id);
        if (formik.values.make === model.make._id) {
          options.push({
            value: model._id,
            label: model.name,
          });
        }
      });
    }
    return options;
  };

  // handle change rotation with
  const handleRotationChange = (index, rotateWithValue) => {
    const updatedAutomaticPositions = [...formik.values.automaticPositions];
    if (rotateWithValue.value === 'clear')
      updatedAutomaticPositions[index] = {
        position: formik.values.tyrePositions[index].value,
        rotateWith: '',
      };
    else
      updatedAutomaticPositions[index] = {
        position: formik.values.tyrePositions[index].value,
        rotateWith: rotateWithValue.value,
      };

    formik.setFieldValue('automaticPositions', updatedAutomaticPositions);
  };

  const getFilteredOptions = (index) => {
    const selectedValues =
      formik?.values?.automaticPositions?.map((pos) => pos.rotateWith) || [];
    const clearOption = { value: 'clear', label: 'Clear' };
    const currentRotateWith =
      formik.values.automaticPositions[index]?.rotateWith || '';

    // Filter out options that are already selected, except for the current value
    const availableOptions = formik.values.tyrePositions.filter(
      (option) =>
        !selectedValues.includes(option.value) ||
        option.value === currentRotateWith
    );

    return [clearOption, ...availableOptions];
  };

  return (
    <Model
      handleClick={handleClick}
      title="Add Vehicle Configuration"
      className="max-w-2xl overflow-x-hidden w-full"
    >
      <div key={data?._id} className="h-full w-full">
        <FormikProvider value={formik}>
          <Form className="px-5 text-gray-700 font-medium text-base grid  lg:gap-x-14 gap-y-5 grid-flow-row grid-cols-1 lg:grid-cols-2 w-full">
            <label className="py-3">
              Select Vehicle Make
              <span className="text-red-500 required-dot">*</span>
              <ReactSelect
                // menuPortalTarget={document.getElementById("modal")}
                // menuPosition="absolute"
                // menuPlacement="auto"
                // menuShouldScrollIntoView={false}
                // classNames={{
                //   control: (state) =>
                //     state.isFocused ? "border-red-600" : "border-grey-300",
                // }}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                menuPlacement="auto"
                
                styles={{
                  control: (base, state) => ({
                    ...base,
                    borderColor: 'transparent',
                    minWidth: '100%',
                    '&:hover': {
                      borderColor: 'rgb(34 197 94)',
                    },
                  }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                    overflow: 'auto',
                    minHeight: 'auto' ,
                  }),
                }}

                className="shadow-md rounded-md py-1 mb-2"
                options={allMakes?.data?.map((make) => ({
                  value: make._id,
                  label: make.make,
                }))}
                value={{
                  value: formik.values.make,
                  label: allMakes?.data?.find(
                    (make) => make?._id === formik.values.make
                  )?.make,
                }}
                onChange={(value) => {
                  formik.setFieldValue('model', null);
                  formik.setFieldValue('make', value.value);
                }}
                name="make"
                isMulti={false}
              />
              {formik.touched.make && formik.errors.make && (
                <p className="text-red-500 font-normal">
                  *{formik.errors.make}
                </p>
              )}
            </label>
            {formik.values.make && (
              <label className="py-3">
                Select Vehicle Model
                <span className="text-red-500 required-dot">*</span>
                <ReactSelect
                  // isDisabled= {data.vehicles}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  menuPlacement="auto"
                  
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: 'transparent',
                      minWidth: '100%',
                      '&:hover': {
                        borderColor: 'rgb(34 197 94)',
                      },
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                      overflow: 'auto',
                      minHeight: 'auto' ,
                    }),
                  }}
                  className="shadow-md rounded-md py-1 mb-2"
                  options={getAllModels()}
                  value={{
                    value: formik.values.model,
                    label: allModels?.data?.find(
                      (d) => d?._id === formik.values.model
                    )?.name,
                  }}
                  onChange={(value) => {
                    formik.setFieldValue('model', value.value);
                  }}
                  name="model"
                  isMulti={false}
                />
                {formik.touched.model && formik.errors.model && (
                  <p className="text-red-500 font-normal">
                    *{formik.errors.model}
                  </p>
                )}
              </label>
            )}
            <InputField
              type="text"
              label="Vehicle Configuration Name"
              name="name"
              value={formik.values.name}
              required={true}
            />
            <InputField
              type="text"
              label="Vehicle Configuration (TREEL)"
              name="axleConfiguration"
              value={formik.values.axleConfiguration}
              required={false}
            />
            <InputField
              desable={data?.vehicles}
              type="text"
              label="Total Wheel Count"
              name="wheelCount"
              value={formik.values.wheelCount}
              required={true}
            />
            {/* <InputField
            type="file"
            label="Vehicle Enforcement Agreement"
            name="agreement"
            formik= {formik}
            key = "agreement"
            required={true}
          /> */}
            <label className="py-3">
              Select Tyre Positions
              <span className="text-red-500 required-dot">*</span>
              <ReactSelect
                menuPortalTarget={document.body}
                menuPosition="fixed"
                menuPlacement="auto"
                
                styles={{
                  control: (base, state) => ({
                    ...base,
                    borderColor: 'transparent',
                    minWidth: '100%',
                    '&:hover': {
                      borderColor: 'rgb(34 197 94)',
                    },
                  }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                    overflow: 'auto',
                    minHeight: 100 ,
                  }),
                }}
                className="shadow-md rounded-md py-1 mb-2"
                isDisabled={data?.vehicles}
                options={tyrePositionsOptions}
                isOptionDisabled={(option) =>
                  formik.values.tyrePositions.length >= formik.values.wheelCount
                }
                value={formik.values.tyrePositions}
                name="tyrePositions"
                onChange={(value) => {
                  formik.setFieldValue('tyrePositions', value);
                }}
                isMulti={true}
              />
              {formik.touched.tyrePositions && formik.errors.tyrePositions && (
                <p className="text-red-500 font-normal">
                  *{formik.errors.tyrePositions}
                </p>
              )}
            </label>
            {formik.values.tyrePositions ? (
              <div className="col-span-2 w-full">
                <label>
                  Automatic Rotation
                  <span className="text-red-500 required-dot">*</span>
                </label>

              {formik.values.tyrePositions.map((position, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 py-2"
                >
                  {/* Position Field */}
                  <div className="flex-1">
                    <InputField
                      type="text"
                      label="Position"
                      name={`automaticPositions[${index}].position`}
                      value={position.label}
                      required={true}
                      key={position.value || index}  
                      />
                  </div>
                  {/* Rotate With Field */}
                  <div className="flex-1">
                    <label className="py-3">
                      Rotation With
                      <span className="text-red-500 required-dot">*</span>
                      <ReactSelect
                          key={`rotation-${position.value || index}`}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          menuPlacement="auto"
                          
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              borderColor: 'transparent',
                              minWidth: '100%',
                              '&:hover': {
                                borderColor: 'rgb(34 197 94)',
                              },
                            }),
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 9999,
                              overflow: 'auto',
                              minHeight: 'auto' ,
                            }),
                          }}
                        className="shadow-md rounded-md py-1 mb-2"
                        options={getFilteredOptions(index)}
                        value={
                          formik.values.automaticPositions[index]?.rotateWith
                            ? formik.values.tyrePositions.find(
                                (tp) =>
                                  tp.value ===
                                  formik.values.automaticPositions[index]
                                    .rotateWith
                              )
                            : null
                        }
                        onChange={(value) => handleRotationChange(index, value)}
                        name={`automaticPositions[${index}].rotateWith`}
                        isMulti={false}
                      />
                      </label>
                    </div>
                    {/* Rotate With Field */}
                    {/* <div className="flex-1">
                      <label className="py-3">
                        Rotation With
                        <span className="text-red-500 required-dot">*</span>
                        <ReactSelect
                           menuPortalTarget={document.body}
                           menuPosition="fixed"
                           menuPlacement="auto"
                           
                           styles={{
                             control: (base, state) => ({
                               ...base,
                               borderColor: 'transparent',
                               minWidth: '100%',
                               '&:hover': {
                                 borderColor: 'rgb(34 197 94)',
                               },
                             }),
                             menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                             menu: (provided) => ({
                               ...provided,
                               zIndex: 9999,
                               overflow: 'auto',
                               minHeight: 'auto' ,
                             }),
                           }}
                          className="shadow-md rounded-md py-1 mb-2"
                          options={getFilteredOptions(index)}
                          value={
                            formik.values.automaticPositions[index]?.rotateWith
                              ? formik.values.tyrePositions.find(
                                  (tp) =>
                                    tp.value ===
                                    formik.values.automaticPositions[index]
                                      .rotateWith
                                )
                              : null
                          }
                          onChange={(value) =>
                            handleRotationChange(index, value)
                          }
                          name={`automaticPositions[${index}].rotateWith`}
                          isMulti={false}
                        />
                        {formik.touched.make && formik.errors.make && (
                          <p className="text-red-500 font-normal">
                            *{formik.errors.make}
                          </p>
                        )}
                        {formik.touched.automaticPositions &&
                          formik.errors.automaticPositions &&
                          formik.errors.automaticPositions[index] && (
                            <p className="text-red-500 font-normal">
                              *{formik.errors.automaticPositions[index]}
                            </p>
                          )}
                      </label>
                    </div> */}
                  </div>
                ))}
              </div>
            ) : (
              <></>
            )}
          </Form>

          {formik.values.agreement && <img src={formik.values.agreement} />}
          <div className="px-5 flex justify-end items-center gap-4 pb-8 flex-wrap sm:w-full">
            <Button bgSecondary onClick={handleClick}>
              Cancel
            </Button>
            <Button type="button" bgPrimary onClick={formik.handleSubmit}>
              Save Changes
            </Button>
          </div>
        </FormikProvider>
      </div>
    </Model>
  );
};

export default Add;
